import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { ProgressSpinner } from 'primereact/progressspinner';

import { setLPDetails } from '../../slices/createLPSlice';
import DefaultEmailTemplate from '../../components/predefinedtemplates/email/DefaultEmailTemplate';
import WebinarEmailTemplate from '../../components/predefinedtemplates/email/WebinarEmailTemplate';
import { hide } from "../../slices/topMenuSlice";
import { LandingPageServe } from '../../services/api/LandingPageServ';
import { setEdit } from "../../slices/authSlice";
import BeckersEmailTemplate from '../../components/predefinedtemplates/email/Demand7EmailTemplate';
import BeckersTemplate from '../../components/predefinedtemplates/lps/beckersDemad7';


const PreviewEmail = () => {
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    dispatch(hide())
    const { id } = useParams();
    const lpDetails = useSelector((state) => state.createLp.data)


    const getLP = async () => {
        try {
            setLoader(true)
            let data = await LandingPageServe.single(id);
            // localStorage.setItem('template_name' , data.templateName)
            dispatch(setLPDetails(data));
            // setLpLayout(lpDetails.lplayout);
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        if (!lpDetails._id) {
            getLP()
        }
        dispatch(setEdit(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lpDetails]);


    return (
        <>
        {loader && <ProgressSpinner aria-label="Loading"  style={{margin : "20% 46%"}}/>}
          {
            (lpDetails.isWebinar && lpDetails.templateName !== "Demand7-Becker's Campaign") && <WebinarEmailTemplate></WebinarEmailTemplate>
        }

        {
           (!lpDetails.isWebinar && lpDetails.templateName !== "Demand7-Becker's Campaign") && <DefaultEmailTemplate></DefaultEmailTemplate>
        }

         {
           (lpDetails.templateName === "Demand7-Becker's Campaign") && <BeckersEmailTemplate></BeckersEmailTemplate>
        }
      </>
    )
}

export default PreviewEmail